(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumoe-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rumoe-review-carousel')) {
    customElements.define('rumoe-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        if (!this.track || !this.cards.length) return;
        this.previous = this.querySelector('[data-review-previous]');
        this.next = this.querySelector('[data-review-next]');
        this.controls = this.querySelector('[data-review-controls]');
        this.position = this.querySelector('[data-review-position]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-review-card]');
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(() => this.updateControls());
        this.resize.observe(this.track);
        this.dataset.ready = 'true';
        this.updateControls();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resize?.disconnect();
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateControls() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
        const bounds = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ box: card.getBoundingClientRect(), index })).filter(({ box }) => box.left >= bounds.left - 2 && box.right <= bounds.right + 2);
        if (visible.length) this.position.textContent = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${this.cards.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumoe-earth-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('earth-explorer')) {
    customElements.define('earth-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const track = this.querySelector('[data-ee-track]');
        const slides = [...this.querySelectorAll('[data-ee-slide]')];
        const thumbs = [...this.querySelectorAll('[data-ee-thumb]')];
        const counter = this.querySelector('[data-ee-current]');
        const dialog = this.querySelector('[data-ee-lightbox]');
        const large = this.querySelector('[data-ee-large]');
        const primary = this.querySelector('[data-ee-primary]');
        const sticky = this.querySelector('[data-ee-sticky]');
        const stickyButton = this.querySelector('[data-ee-sticky-buy]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelectorAll('.ee-topline__right, .ee-button--outline').forEach((link) => link.addEventListener('click', (event) => {
          const target = this.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          event.stopPropagation();
          window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - 120, behavior: reduced ? 'instant' : 'smooth' });
        }));
        let active = 0;
        const show = (index) => {
          const target = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: reduced ? 'instant' : 'smooth' });
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', (event) => { event.preventDefault(); show(index); }));
        this.querySelector('[data-ee-prev]').addEventListener('click', () => show(active - 1));
        this.querySelector('[data-ee-next]').addEventListener('click', () => show(active + 1));
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1)); }
        });
        this.slideObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < .6) return;
            active = slides.indexOf(entry.target);
            counter.textContent = String(active + 1).padStart(2, '0');
            thumbs.forEach((thumb, index) => index === active ? thumb.setAttribute('aria-current', 'true') : thumb.removeAttribute('aria-current'));
          });
        }, { root: track, threshold: .6 });
        slides.forEach((slide) => this.slideObserver.observe(slide));
        this.querySelectorAll('[data-ee-zoom]').forEach((button) => button.addEventListener('click', () => {
          const image = button.querySelector('img');
          const url = new URL(image.currentSrc || image.src, window.location.origin);
          url.searchParams.set('width', '2000');
          large.src = url.href;
          large.alt = image.alt;
          dialog.showModal();
        }));
        this.querySelector('[data-ee-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        this.buyObserver = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: .2 });
        this.buyObserver.observe(primary);
        stickyButton.addEventListener('click', () => {
          if (primary.disabled || primary.getAttribute('aria-disabled') === 'true') return;
          primary.click();
        });
        this.buttonObserver = new MutationObserver(() => {
          stickyButton.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
          stickyButton.setAttribute('aria-busy', primary.classList.contains('loading') ? 'true' : 'false');
        });
        this.buttonObserver.observe(primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
        const error = this.querySelector('.ee-error');
        this.errorObserver = new MutationObserver(() => {
          if (error.hidden || !error.textContent.trim()) return;
          const rect = error.getBoundingClientRect();
          if (rect.top < 120 || rect.bottom > window.innerHeight - 90) window.scrollTo({ top: window.scrollY + rect.top - 140, behavior: reduced ? 'instant' : 'smooth' });
        });
        this.errorObserver.observe(error, { attributes:true, attributeFilter:['hidden'], childList:true, subtree:true, characterData:true });
      }
      disconnectedCallback() {
        this.slideObserver?.disconnect();
        this.buyObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.errorObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
